export default "__VITE_ASSET__MHdfhuZN__"